import {
  EarningsInsightType,
  IconDisplayRule,
  SummaryInsightType,
} from '@toggle/toggle';

export type InsightsPeriod = {
  duration: number;
  unit: string;
};

export type WatchlistSelection = { id: string; includeCompetitors: boolean };

export enum POP_UP_KEYS {
  EXPLORE_BANNER_NO_REPEAT = 'EXPLORE_BANNER_NO_REPEAT',
  MY_TOGGLE_BANNER_NO_REPEAT = 'MY_TOGGLE_BANNER_NO_REPEAT',
  PORTFOLIO_CONNECTION_BANNER_NO_REPEAT = 'PORTFOLIO_CONNECTION_BANNER_NO_REPEAT',
}

export enum SubscriptionAlertKeys {
  WasTrial = 'TRIAL_STARTED',
  ShowDowngradeAlert = 'SHOW_DOWNGRADE_ALERT',
  SubscriptionEndedInlineAlertDismissed = 'SUBSCRIPTION_ENDED_INLINE_ALERT_DISMISSED',
}

export type ContinueContextButtonKeys =
  | 'CHAT_DOCUMENT_SEARCH_CONTEXT_SEEN'
  | 'CHAT_DOCUMENT_SEARCH_CONTEXT_SEEN_DOC_VIEW';

export const AO_SELECTED_HORIZON = 'AO_SELECTED_HORIZON';
export const THEME_NAME_STORAGE_KEY = 'THEME_NAME';
export const LANGUAGE_SETTING = 'LANGUAGE_SETTING';
export const FAVORITE_WATCHLIST = 'FAVORITE_WATCHLIST';
export const CHART_WIDGET_RECENTLY_OPENED_ENTITIES =
  'CHART_WIDGET_RECENTLY_OPENED_ENTITIES';
export const AO_WIDGET_RECENTLY_OPENED_ENTITIES =
  'AO_WIDGET_RECENTLY_OPENED_ENTITIES';
export const RECENTLY_OPENED_THEMES_OR_ENTITIES =
  'RECENTLY_OPENED_THEMES_OR_ENTITIES';
export const DASHBOARD_VIEW_MODE = 'DASHBOARD_VIEW_MODE';
export const NEWS_RECENT_SEARCHES = 'NEWS_RECENT_SEARCHES';
export const WHATS_NEW_PERIOD = 'WHATS_NEW_PERIOD';
export const WHATS_NEW_SELECTED_WATCHLISTS = 'WHATS_NEW_SELECTED_WATCHLISTS';
export const WHATS_NEW_INSIGHT_TYPES = 'WHATS_NEW_INSIGHT_TYPES';
export const WHATS_NEW_EARNINGS_TYPES = 'WHATS_NEW_EARNINGS_TYPES';
export const WHATS_NEW_SUMMARY_TYPES = 'WHATS_NEW_SUMMARY_TYPES';
export const WHATS_NEW_INCLUDE_COMPETITORS = 'WHATS_NEW_INCLUDE_COMPETITORS';
export const ONBOARDING_STATE = 'ONBOARDING_STATE';
export const EVENT_ECONOMIC_COUNTRY_FILTER = 'EVENT_ECONOMIC_COUNTRY_FILTER';
export const READ_MARKET_INSIGHTS = 'READ_MARKET_INSIGHTS';
export const READ_INSIGHTS = 'READ_INSIGHTS';
export const READ_EARNINGS_INSIGHTS = 'READ_EARNINGS_INSIGHTS';
export const STREAM_SELECTED_WATCHLISTS = 'STREAM_SELECTED_WATCHLISTS';

export type ReadAssetInsightItem = { id: string; dateISO: string };
export type ReadEarningsInsightItem = { id: string; dateISO: string };
export type ReadCatalystInsightItem = Record<string, string[]>;

export type STORAGE_KEYS =
  | POP_UP_KEYS
  | SubscriptionAlertKeys
  | typeof AO_SELECTED_HORIZON
  | typeof THEME_NAME_STORAGE_KEY
  | typeof LANGUAGE_SETTING
  | typeof FAVORITE_WATCHLIST
  | typeof CHART_WIDGET_RECENTLY_OPENED_ENTITIES
  | typeof AO_WIDGET_RECENTLY_OPENED_ENTITIES
  | typeof DASHBOARD_VIEW_MODE
  | typeof RECENTLY_OPENED_THEMES_OR_ENTITIES
  | typeof NEWS_RECENT_SEARCHES
  | typeof WHATS_NEW_PERIOD
  | typeof WHATS_NEW_SELECTED_WATCHLISTS
  | typeof WHATS_NEW_INSIGHT_TYPES
  | typeof WHATS_NEW_EARNINGS_TYPES
  | typeof WHATS_NEW_SUMMARY_TYPES
  | typeof WHATS_NEW_INCLUDE_COMPETITORS
  | typeof ONBOARDING_STATE
  | typeof EVENT_ECONOMIC_COUNTRY_FILTER
  | typeof READ_MARKET_INSIGHTS
  | typeof READ_INSIGHTS
  | typeof READ_EARNINGS_INSIGHTS
  | typeof STREAM_SELECTED_WATCHLISTS
  | ContinueContextButtonKeys
  | 'feature_flags';

export type STORAGE_ITEMS = {
  [K in STORAGE_KEYS]?: K extends typeof READ_INSIGHTS
    ? ReadAssetInsightItem[]
    : K extends typeof READ_EARNINGS_INSIGHTS
    ? ReadEarningsInsightItem[]
    : K extends typeof READ_MARKET_INSIGHTS
    ? ReadCatalystInsightItem
    : K extends typeof WHATS_NEW_SELECTED_WATCHLISTS
    ? WatchlistSelection[]
    : K extends typeof WHATS_NEW_PERIOD
    ? InsightsPeriod
    : K extends typeof WHATS_NEW_INCLUDE_COMPETITORS
    ? boolean
    : K extends typeof WHATS_NEW_INSIGHT_TYPES
    ? IconDisplayRule[]
    : K extends typeof WHATS_NEW_EARNINGS_TYPES
    ? EarningsInsightType[]
    : K extends typeof WHATS_NEW_SUMMARY_TYPES
    ? SummaryInsightType[]
    : string | string[] | object | boolean;
};
